import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import closeButton from 'src/images/settingclose.svg';
import { useHistory } from 'react-router';

const useStyles = makeStyles(() => ({
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  closeWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end'
  },
  GuestModalWrapper: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
    borderRadius: '10px',
    width: '450px',
    height: '400px',
    backgroundColor: 'white',
    padding: '35px',
    display: 'flex',
    flexDirection: 'column'
  },
  GuestModalContent: {
    fontFamily: 'Archivo',
    width: 322,
    display: 'flex',
    flexDirection: 'column',
    margin: '30px 0',
    gap: 10,
    textAlign: 'center'
  }
}));
const GuestModal = ({ onClickGuestModal }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleOutsideClick = e => {
    if (e.target === e.currentTarget) {
      onClickGuestModal();
    }
  };
  const onClickRegisterButton = () => {
    history.push('/register');
  };
  return (
    <div className={classes.modalOverlay} onClick={handleOutsideClick}>
      <div className={classes.GuestModalWrapper}>
        <div className={classes.closeWrapper}>
          <button
            style={{ background: '#fff', border: 'none', cursor: 'pointer' }}
            onClick={onClickGuestModal}
          >
            <img
              alt="close"
              src={closeButton}
              style={{ width: 15, height: 15 }}
            />
          </button>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <img
            src={require('src/images/LockIcon.png')}
            alt="lock"
            width={95}
            height={95}
          />
          <div className={classes.GuestModalContent}>
            <p
              style={{
                fontWeight: 600,
                fontSize: '22px'
              }}
            >
              Become a IAM Studio User
            </p>
            <p
              style={{
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '21px'
              }}
            >
              Start free trial to get all features of IAM Studio Free for 14
              days
            </p>
          </div>
        </div>
        <button
          style={{
            width: '100%',
            height: '56px',
            background: 'black',
            color: 'white',
            fontSize: 18,
            fontWeight: 700,
            fontFamily: 'Archivo',
            border: 'none',
            borderRadius: 10,
            marginTop: 30,
            cursor: 'pointer'
          }}
          onClick={onClickRegisterButton}
        >
          Start free trial
        </button>
      </div>
    </div>
  );
};
export default GuestModal;
